import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import FormularioContrato from '../Formulario/FormularioContrato';
import { usePermissoes } from '../utils/PermissoesContext';
import { getAuthToken } from '../utils/auth';
import './Dropdown.css';
import BASE_URL from '../utils/api';
import useRecarregarQuandoConcluir from '../utils/useRecarregarQuandoConcluir';

function MobileAddListener({ onOpen }) {
  useEffect(() => {
    window.addEventListener('open-mobile-add-popup', onOpen);
    return () => window.removeEventListener('open-mobile-add-popup', onOpen);
  }, [onOpen]);
  return null;
}

export default function ContratoDropdown() {
  // Contrato assinado (em outra aba, outro aparelho ou pela Assinafy): recarrega a página sozinha
  useRecarregarQuandoConcluir('Contrato/status-resumo', c => /assinad/i.test(c.status || c.Status || '') || /^(signed|certificated|certificating)$/i.test(c.statusAssinaturaDigital || c.StatusAssinaturaDigital || ''));
  const navigate = useNavigate();
  const { temPermissao } = usePermissoes();
  const [contratos, setContratos] = useState([]);
  const [contratosFiltrados, setContratosFiltrados] = useState([]);
  const [contratoEditando, setContratoEditando] = useState(null);
  const [clientesCache, setClientesCache] = useState({});

  const atualizarContratoNaLista = (contratoAtualizado) => {
    const idAtual = contratoAtualizado.id ?? contratoAtualizado.Id;
    if (!idAtual) return;

    setContratos(prev => prev.map(c => {
      const cId = c.id ?? c.Id;
      return cId === idAtual ? { ...c, ...contratoAtualizado } : c;
    }));

    setContratosFiltrados(prev => prev.map(c => {
      const cId = c.id ?? c.Id;
      return cId === idAtual ? { ...c, ...contratoAtualizado } : c;
    }));

    setContratoEditando(prev => {
      const prevId = prev?.id ?? prev?.Id;
      return prevId === idAtual ? { ...prev, ...contratoAtualizado } : prev;
    });
  };
  const [orcamentosCache, setOrcamentosCache] = useState({});
  const [oportunidadesCache, setOportunidadesCache] = useState({});
  
  // Estados para fluxo de criação de contrato
  const [showClientePopup, setShowClientePopup] = useState(false);
  const [showOportunidadePopup, setShowOportunidadePopup] = useState(false);
  const [showOrcamentoPopup, setShowOrcamentoPopup] = useState(false);
  const [clientesLista, setClientesLista] = useState([]);
  const [oportunidadesLista, setOportunidadesLista] = useState([]);
  const [orcamentosLista, setOrcamentosLista] = useState([]);
  const [clienteSelecionadoNovo, setClienteSelecionadoNovo] = useState(null);
  const [oportunidadeSelecionadaNovo, setOportunidadeSelecionadaNovo] = useState(null);
  const [loadingPopup, setLoadingPopup] = useState(false);
  
  // Estados para filtro seguindo padrão do site
  const [filtro, setFiltro] = useState('idContrato');
  const [valorFiltro, setValorFiltro] = useState('');
  const [dropdownAberto, setDropdownAberto] = useState(false);

  useEffect(() => {
    fetchContratos();
  }, []);

  // Aplicar filtro quando contratos ou valorFiltro mudarem
  useEffect(() => {
    aplicarFiltro(valorFiltro);
  }, [contratos, filtro]);

  const fetchContratos = async () => {
    try {
      console.log('🔄 Buscando contratos...');
      
      // URLs de fallback para conectar com a API
      const urls = [
        `${BASE_URL}/Contrato`,
        `${BASE_URL}/Contrato`,
        `${BASE_URL}/Contrato`,
        `${BASE_URL}/Contrato`,
        `${BASE_URL}/Contrato`
      ];

      for (const url of urls) {
        try {
          console.log(`🔄 Tentando conectar em: ${url}`);
          const headers = {};
          const token = getAuthToken();
          if (token) headers['Authorization'] = `Bearer ${token}`;
          const response = await fetch(url, { headers });
          if (response.ok) {
            const data = await response.json();
            console.log('📊 Contratos recebidos (brutos):', data);
            console.log('📊 Primeiro item BRUTO:', data[0]);
            console.log('📊 Tipo do primeiro item:', typeof data[0]);
            console.log('📊 Chaves do primeiro item:', data[0] ? Object.keys(data[0]) : 'vazio');
            
            // Log detalhado do primeiro contrato
            if (data[0]) {
              console.log('🔍 ESTRUTURA DETALHADA do primeiro contrato:');
              console.log('  - Tem contrato (minúsculo)?', data[0].contrato);
              console.log('  - Tem Contrato (maiúsculo)?', data[0].Contrato);
              console.log('  - Tem Id direto?', data[0].Id);
              console.log('  - Tem id direto?', data[0].id);
              if (data[0].contrato) {
                console.log('  - contrato.id?', data[0].contrato.id);
                console.log('  - contrato.vendaId?', data[0].contrato.vendaId);
                console.log('  - contrato.id_cliente?', data[0].contrato.id_cliente);
                console.log('  - contrato.orcamentosId?', data[0].contrato.orcamentosId);
                console.log('  - contrato.valor?', data[0].contrato.valor);
                console.log('  - contrato.status?', data[0].contrato.status);
              }
              if (data[0].Contrato) {
                console.log('  - Contrato.Id?', data[0].Contrato.Id);
                console.log('  - Contrato.VendaId?', data[0].Contrato.VendaId);
                console.log('  - Contrato.Id_cliente?', data[0].Contrato.Id_cliente);
                console.log('  - Contrato.OrcamentosId?', data[0].Contrato.OrcamentosId);
                console.log('  - Contrato.Valor?', data[0].Contrato.Valor);
                console.log('  - Contrato.Status?', data[0].Contrato.Status);
              }
            }

            // Normaliza SEMPRE cada item, seja flat (do novo endpoint) ou wrapper { Contrato, ... }
            const normalizados = Array.isArray(data) ? data.map((item, index) => {
              // Tenta minúscula E maiúscula (API pode retornar em qualquer formato)
              const c = item?.contrato ?? item?.Contrato ?? item ?? {};

              const cliente = item?.cliente ?? item?.Cliente ?? null;
              const contatos = item?.clienteContatos ?? item?.ClienteContatos ?? null;
              const enderecos = item?.clienteEnderecos ?? item?.ClienteEnderecos ?? null;
              const documentos = item?.clienteDocumentos ?? item?.ClienteDocumentos ?? null;
              const orcamento = item?.orcamento ?? item?.Orcamento ?? null;

              const out = {
                // IDs e chaves
                Id: c.Id ?? item?.Id,
                id: (c.Id ?? item?.Id ?? c.id),

                // Relacionamentos
                OrcamentosId: c.OrcamentosId ?? c.orcamentosId ?? item?.OrcamentosId,
                orcamentosId: c.OrcamentosId ?? c.orcamentosId ?? item?.orcamentosId,
                Id_cliente: c.Id_cliente ?? c.id_cliente ?? item?.Id_cliente,
                id_cliente: c.Id_cliente ?? c.id_cliente ?? item?.id_cliente,
                VendaId: c.VendaId ?? c.vendaId ?? item?.VendaId,
                vendaId: c.VendaId ?? c.vendaId ?? item?.vendaId,

                // Valores principais
                Valor: c.Valor ?? c.valor ?? item?.Valor,
                valor: c.Valor ?? c.valor ?? item?.valor,
                DescontoAdicional: c.DescontoAdicional ?? c.descontoAdicional ?? item?.DescontoAdicional,
                descontoAdicional: c.DescontoAdicional ?? c.descontoAdicional ?? item?.descontoAdicional,
                Status: c.Status ?? c.status ?? item?.Status,
                status: c.Status ?? c.status ?? item?.status,
                DataCriacao: c.DataCriacao ?? c.dataCriacao ?? item?.DataCriacao,
                dataCriacao: c.DataCriacao ?? c.dataCriacao ?? item?.dataCriacao,

                // Datas adicionais
                Data_assinatura: c.Data_assinatura ?? c.data_assinatura ?? item?.Data_assinatura,
                data_assinatura: c.Data_assinatura ?? c.data_assinatura ?? item?.data_assinatura,
                DataVigencia: c.DataVigencia ?? c.dataVigencia ?? item?.DataVigencia,
                dataVigencia: c.DataVigencia ?? c.dataVigencia ?? item?.dataVigencia,
                Prazo_garantia: c.Prazo_garantia ?? c.prazo_garantia ?? item?.Prazo_garantia,
                prazo_garantia: c.Prazo_garantia ?? c.prazo_garantia ?? item?.prazo_garantia,
                Data_garantia: c.Data_garantia ?? c.data_garantia ?? item?.Data_garantia,
                data_garantia: c.Data_garantia ?? c.data_garantia ?? item?.data_garantia,

                // Textos
                DescricaoOrcamento: c.DescricaoOrcamento ?? c.descricaoOrcamento ?? item?.DescricaoOrcamento,
                descricaoOrcamento: c.DescricaoOrcamento ?? c.descricaoOrcamento ?? item?.descricaoOrcamento,
                CondicoesPagto: c.CondicoesPagto ?? c.condicoesPagto ?? item?.CondicoesPagto,
                condicoesPagto: c.CondicoesPagto ?? c.condicoesPagto ?? item?.condicoesPagto,
                ServicosContratados: c.ServicosContratados ?? c.servicosContratados ?? item?.ServicosContratados,
                servicosContratados: c.ServicosContratados ?? c.servicosContratados ?? item?.servicosContratados,

                // Extras para UI
                ClienteNome: cliente?.Nome ?? item?.ClienteNome ?? null,
                ClienteEmail: contatos?.Email ?? cliente?.Email ?? item?.ClienteEmail ?? null,
                ClienteCelular: contatos?.Celular ?? cliente?.Celular ?? item?.ClienteCelular ?? null,
                ClienteEndereco: enderecos?.Endereco ?? null,
                ClienteCidade: enderecos?.Cidade ?? null,
                ClienteUF: enderecos?.UF ?? null,
                ClienteCPF_CNPJ: documentos?.CPF_CNPJ ?? item?.ClienteCPF_CNPJ ?? null,
                OrcamentoTitulo: orcamento?.Titulo ?? item?.OrcamentoTitulo ?? null,
              };

              if (index === 0) {
                console.log('🔍 Primeiro contrato APÓS normalização:', out);
              }

              return out;
            }) : [];

            console.log('🔍 Contratos NORMALIZADOS (primeiros 2):', normalizados.slice(0, 2));
            console.log('🔍 Total de contratos normalizados:', normalizados.length);
            
            setContratos(normalizados);
            setContratosFiltrados(normalizados);
            // Tentar popular nomes de cliente e títulos de oportunidade quando faltarem
            populateRelatedNames(normalizados);
            console.log(`✅ Sucesso em: ${url} - ${data.length} contratos carregados`);
            return;
          }
          console.log(`❌ Falha em: ${url} - Status: ${response.status}`);
        } catch (error) {
          console.log(`❌ Erro em: ${url} - ${error.message}`);
        }
      }
      
      console.log('❌ Nenhuma URL da API funcionou');
      setContratos([]);
      setContratosFiltrados([]);
    } catch (e) {
      console.error('❌ Erro ao buscar contratos:', e);
      setContratos([]);
      setContratosFiltrados([]);
    }
  };

  // Garantir re-população quando a lista de contratos mudar (ex.: após edição)
  const populatedIdsRef = useRef(new Set());
  useEffect(() => {
    if (!contratos || !contratos.length) return;
    // Só popula se houver contratos novos que ainda não foram populados
    const hasNew = contratos.some(c => {
      const id = c.id ?? c.Id;
      return id && !populatedIdsRef.current.has(id);
    });
    if (!hasNew) return;
    contratos.forEach(c => { const id = c.id ?? c.Id; if (id) populatedIdsRef.current.add(id); });
    populateRelatedNames(contratos);
  }, [contratos]);

  // Log do primeiro contrato apenas quando ele mudar (evita spam de console)
  const prevFirstContratoRef = useRef(null);
  useEffect(() => {
    const first = (contratosFiltrados && contratosFiltrados.length) ? contratosFiltrados[0] : null;
    const firstId = first ? (first.id ?? first.Id) : null;
    if (first && prevFirstContratoRef.current !== firstId) {
      console.log('🎨 Primeiro contrato agora:', first);
      console.log('  - contratoId:', firstId);
      console.log('  - vendaId:', first?.vendaId ?? first?.VendaId);
      console.log('  - clienteId:', first?.id_cliente ?? first?.Id_cliente);
      console.log('  - orcamentoId:', first?.orcamentosId ?? first?.OrcamentosId);
      console.log('  - valor:', first?.valor ?? first?.Valor);
      console.log('  - status:', first?.status ?? first?.Status);
      prevFirstContratoRef.current = firstId;
    }
  }, [contratosFiltrados]);

  // Notifica AjudaWidget quando o formulário de contrato abre/fecha
  useEffect(() => {
    window.dispatchEvent(new CustomEvent('contrato-popup-state', {
      detail: { formularioAberto: !!contratoEditando }
    }));
  }, [contratoEditando]);

  // Fecha todos os popups quando AjudaWidget solicitar
  useEffect(() => {
    const handler = () => {
      fecharTodosPopupsNovo();
      setContratoEditando(null);
      setDropdownAberto(false);
    };
    window.addEventListener('contrato-fechar-todos-popups', handler);
    return () => window.removeEventListener('contrato-fechar-todos-popups', handler);
  }, []);

  // Preenche ClienteNome e OrcamentoTitulo para contratos que estejam vazios,
  // buscando pelos IDs e cacheando os resultados.
  const populateRelatedNames = async (contracts) => {
    try {
      const clientIds = new Set();
      const orcamentoIds = new Set();

      contracts.forEach(c => {
        const clienteId = c.id_cliente || c.Id_cliente || c.idCliente || c.Id_cliente;
        const orcId = c.orcamentosId || c.OrcamentosId || c.orcamentoId;
        if (clienteId && !(clientesCache[clienteId])) clientIds.add(clienteId);
        if (orcId && !(orcamentosCache[orcId])) orcamentoIds.add(orcId);
      });

      // Buscar clientes (coletar localmente para evitar condição de corrida)
      const foundClients = {};
      if (clientIds.size > 0) {
        for (const id of Array.from(clientIds)) {
          const urls = [
            `${BASE_URL}/Cliente/${id}`,
            `${BASE_URL}/Cliente/${id}`,
            `${BASE_URL}/Cliente/${id}`,
            `${BASE_URL}/Cliente/${id}`
          ];
          for (const url of urls) {
            try {
              const resp = await fetch(url, { headers: { 'Authorization': 'Bearer ' + (getAuthToken() || '') } });
              if (resp.ok) {
                const data = await resp.json();
                foundClients[id] = data.Nome || data.nome || data.NomeFantasia || '';
                break;
              }
            } catch (e) { continue; }
          }
        }
        // Mesclar ao cache global
        if (Object.keys(foundClients).length > 0) setClientesCache(prev => ({ ...prev, ...foundClients }));
      }

      // Buscar orçamentos e, a partir deles, oportunidades
      const oportunidadeIdsToFetch = new Set();
      const foundOrcamentos = {};
      if (orcamentoIds.size > 0) {
        for (const id of Array.from(orcamentoIds)) {
          const urls = [
            `${BASE_URL}/Orcamento/${id}`,
            `${BASE_URL}/Orcamento/${id}`,
            `${BASE_URL}/Orcamento/${id}`,
            `${BASE_URL}/Orcamento/${id}`
          ];
          for (const url of urls) {
            try {
              const resp = await fetch(url, { headers: { 'Authorization': 'Bearer ' + (getAuthToken() || '') } });
              if (resp.ok) {
                const data = await resp.json();
                foundOrcamentos[id] = data;
                if (data.OportunidadeId || data.oportunidadeId || data.OportunidadeID) {
                  const oppId = data.OportunidadeId ?? data.oportunidadeId ?? data.OportunidadeID;
                  oportunidadeIdsToFetch.add(oppId);
                }
                break;
              }
            } catch (e) { continue; }
          }
        }
        if (Object.keys(foundOrcamentos).length > 0) setOrcamentosCache(prev => ({ ...prev, ...foundOrcamentos }));
      }

      // Buscar oportunidades pelo id
      const foundOportunidades = {};
      if (oportunidadeIdsToFetch.size > 0) {
          for (const id of Array.from(oportunidadeIdsToFetch)) {
          const urls = [
            `${BASE_URL}/Oportunidade/${id}`,
            `${BASE_URL}/Oportunidade/${id}`,
            `${BASE_URL}/Oportunidade/${id}`,
            `${BASE_URL}/Oportunidade/${id}`
          ];
          for (const url of urls) {
            try {
              const resp = await fetch(url, { headers: { 'Authorization': 'Bearer ' + (getAuthToken() || '') } });
              if (resp.ok) {
                const data = await resp.json();
                // Normalize title key from backend which may return Oportunidade_Titulo
                if (data && !data.Titulo && data.Oportunidade_Titulo) data.Titulo = data.Oportunidade_Titulo;
                foundOportunidades[id] = data;
                break;
              }
            } catch (e) { continue; }
          }
        }
        if (Object.keys(foundOportunidades).length > 0) setOportunidadesCache(prev => ({ ...prev, ...foundOportunidades }));
      }

      // Atualizar contratos em memória com os nomes/títulos encontrados
      // Merge caches we have just collected with the current caches to use locally
      const mergedClientes = { ...clientesCache, ...foundClients };
      const mergedOrcamentos = { ...orcamentosCache, ...foundOrcamentos };
      const mergedOportunidades = { ...oportunidadesCache, ...foundOportunidades };

      setContratos(prev => prev.map(c => {
        const clienteId = c.id_cliente || c.Id_cliente || c.idCliente;
        const orcId = c.orcamentosId || c.OrcamentosId || c.orcamentoId;
        const clienteNome = (clienteId && (mergedClientes[clienteId] || '')) || c.ClienteNome || c.clienteNome || '';
        let orcTitulo = c.OrcamentoTitulo || c.orcamentoTitulo || '';
        if (!orcTitulo && orcId && mergedOrcamentos[orcId]) {
          const o = mergedOrcamentos[orcId];
          orcTitulo = o.DescricaoOrcamento || o.descricaoOrcamento || o.Titulo || o.titulo || '';
          if (!orcTitulo && (o.OportunidadeId || o.oportunidadeId)) {
            const oppId = o.OportunidadeId ?? o.oportunidadeId;
            const opp = mergedOportunidades[oppId];
            if (opp) orcTitulo = opp.Titulo || opp.titulo || opp.Nome || '';
          }
        }

        return {
          ...c,
          ClienteNome: clienteNome || c.ClienteNome,
          OrcamentoTitulo: orcTitulo || c.OrcamentoTitulo
        };
      }));
    } catch (err) {
      console.warn('Erro ao popular nomes relacionados:', err);
    }
  };

  // Função para baixar PDF do contrato através do endpoint `/api/Contrato/{id}/pdf`
  const baixarPdfContrato = async (id) => {
    if (!id) {
      alert('ID do contrato inválido para download.');
      return;
    }

    const urls = [
      // Prefer the explicit download endpoint implemented in backend
      `${BASE_URL}/Contrato/download-pdf/${id}`,
      `${BASE_URL}/Contrato/download-pdf/${id}`,
      `${BASE_URL}/Contrato/download-pdf/${id}`,
      `${BASE_URL}/Contrato/download-pdf/${id}`,
      `${BASE_URL}/Contrato/download-pdf/${id}`,
      // Backward compat: older endpoints /Contrato/{id}/pdf
      `${BASE_URL}/Contrato/${id}/pdf`,
      `${BASE_URL}/Contrato/${id}/pdf`,
      `${BASE_URL}/Contrato/${id}/pdf`,
      `${BASE_URL}/Contrato/${id}/pdf`,
      `${BASE_URL}/Contrato/${id}/pdf`
    ];

    for (const url of urls) {
      try {
        const resp = await fetch(url, { method: 'GET', headers: { 'Authorization': 'Bearer ' + (getAuthToken() || '') } });
        if (resp.ok) {
          const blob = await resp.blob();
          if (!blob || blob.size === 0) {
            alert('PDF não disponível para este Contrato.');
            return;
          }

          // Extrair nome do arquivo, se existir
          const dispo = resp.headers.get('Content-Disposition') || '';
          let fileName = `Contrato_${id}.pdf`;
          const match = /filename\*=UTF-8''(.+)$/.exec(dispo) || /filename="?([^";]+)"?/.exec(dispo);
          if (match && match[1]) fileName = decodeURIComponent(match[1]);

          const urlBlob = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = urlBlob;
          a.download = fileName;
          document.body.appendChild(a);
          a.click();
          a.remove();
          window.URL.revokeObjectURL(urlBlob);
          return;
        }
      } catch (error) {
        // tentar próxima URL
        console.warn('Erro ao tentar baixar PDF do contrato em', url, error.message || error);
      }
    }

    alert('Não foi possível baixar o PDF do contrato. Verifique se o backend está rodando ou se o PDF existe.');
  };

  // Funções de filtro seguindo padrão do site
  const handleFiltroChange = (novoFiltro) => {
    setFiltro(novoFiltro);
    setDropdownAberto(false);
    setValorFiltro('');
    // Resetar para todos os contratos quando muda o filtro
    setContratosFiltrados(contratos);
  };

  const handleInputChange = (e) => {
    const valor = e.target.value;
    setValorFiltro(valor);
    aplicarFiltro(valor);
  };

  const aplicarFiltro = (valor) => {
    if (!valor.trim()) {
      setContratosFiltrados(contratos);
      return;
    }

    const filtradas = contratos.filter(contrato => {
      const valorLower = valor.toLowerCase();
      
      if (filtro === 'idContrato') {
        const id = contrato.id || contrato.Id || '';
        return String(id).includes(valor);
      }
      if (filtro === 'idCliente') {
        const idCliente = contrato.id_cliente || contrato.Id_cliente || '';
        return String(idCliente).includes(valor);
      }
      if (filtro === 'idOrcamento') {
        const idOrcamento = contrato.orcamentosId || contrato.OrcamentosId || '';
        return String(idOrcamento).includes(valor);
      }
      if (filtro === 'status') {
        const status = contrato.status || contrato.Status || '';
        return status.toLowerCase().includes(valorLower);
      }
      if (filtro === 'valor') {
        const valorContrato = contrato.valor || contrato.Valor || '';
        return String(valorContrato).includes(valor);
      }
      return true;
    });

    setContratosFiltrados(filtradas);
  };

  // === Funções para fluxo de criação de contrato ===
  const fetchClientesParaNovo = async () => {
    setLoadingPopup(true);
    try {
      const urls = [`${BASE_URL}/Cliente`, `${BASE_URL}/Cliente`];
      for (const url of urls) {
        try {
          const resp = await fetch(url, { headers: { 'Authorization': 'Bearer ' + (getAuthToken() || '') } });
          if (resp.ok) { setClientesLista(await resp.json()); return; }
        } catch (e) { /* next */ }
      }
      setClientesLista([]);
    } catch (e) { setClientesLista([]); } finally { setLoadingPopup(false); }
  };

  const fetchOportunidadesPorCliente = async (clienteId) => {
    setLoadingPopup(true);
    try {
      const urls = [`${BASE_URL}/Oportunidade`, `${BASE_URL}/Oportunidade`];
      for (const url of urls) {
        try {
          const resp = await fetch(url, { headers: { 'Authorization': 'Bearer ' + (getAuthToken() || '') } });
          if (resp.ok) {
            const data = await resp.json();
            const filtradas = (data || []).filter(op => {
              const cId = op.clienteId || op.ClienteId;
              return cId === clienteId || cId === parseInt(clienteId);
            });
            setOportunidadesLista(filtradas);
            return;
          }
        } catch (e) { /* next */ }
      }
      setOportunidadesLista([]);
    } catch (e) { setOportunidadesLista([]); } finally { setLoadingPopup(false); }
  };

  const fetchOrcamentosPorOportunidade = async (oportunidadeId, clienteId) => {
    setLoadingPopup(true);
    try {
      const urls = [`${BASE_URL}/Orcamento`, `${BASE_URL}/Orcamento`];
      for (const url of urls) {
        try {
          const resp = await fetch(url, { headers: { 'Authorization': 'Bearer ' + (getAuthToken() || '') } });
          if (resp.ok) {
            const data = await resp.json();
            const filtrados = (data || []).filter(orc => {
              const orcOppId = orc.oportunidadeId || orc.OportunidadeId;
              return orcOppId === oportunidadeId || orcOppId === parseInt(oportunidadeId);
            });
            setOrcamentosLista(filtrados);
            return;
          }
        } catch (e) { /* next */ }
      }
      setOrcamentosLista([]);
    } catch (e) { setOrcamentosLista([]); } finally { setLoadingPopup(false); }
  };

  const handleNovoContrato = () => {
    fetchClientesParaNovo();
    setShowClientePopup(true);
  };

  const fecharTodosPopupsNovo = () => {
    setShowClientePopup(false);
    setShowOportunidadePopup(false);
    setShowOrcamentoPopup(false);
    setClienteSelecionadoNovo(null);
    setOportunidadeSelecionadaNovo(null);
  };

  const handleSelecionarClienteNovo = (cliente) => {
    setClienteSelecionadoNovo(cliente);
    setShowClientePopup(false);
    setShowOportunidadePopup(true);
    fetchOportunidadesPorCliente(cliente.id || cliente.Id);
  };

  const handleSelecionarOportunidadeNovo = (oportunidade) => {
    setOportunidadeSelecionadaNovo(oportunidade);
    setShowOportunidadePopup(false);
    setShowOrcamentoPopup(true);
    fetchOrcamentosPorOportunidade(oportunidade.id || oportunidade.Id, clienteSelecionadoNovo?.id || clienteSelecionadoNovo?.Id);
  };

  const handleSelecionarOrcamentoNovo = (orcamento) => {
    const orcId = orcamento.id || orcamento.Id;
    const clienteId = clienteSelecionadoNovo?.id || clienteSelecionadoNovo?.Id;
    fecharTodosPopupsNovo();
    // Abrir o formulário de edição com um contrato "novo" pré-preenchido
    setContratoEditando({
      id: null,
      orcamentosId: orcId,
      OrcamentosId: orcId,
      id_cliente: clienteId,
      Id_cliente: clienteId,
      status: 'Pendente Assinatura',
      Status: 'Pendente Assinatura',
      _isNew: true
    });
  };

  return (
    <div className="container-geral fundo-branco">
      <MobileAddListener onOpen={handleNovoContrato} />

      {/* Personalizar contrato (cláusulas do PDF), no lugar do "adicionar" */}
      <div style={{ display: 'flex', justifyContent: 'center', margin: '20px 0' }}>
        <button
          type="button"
          onClick={() => window.open('/personalizar-contrato', '_blank')}
          style={{ padding: '12px 24px', backgroundColor: 'rgb(235, 133, 0)', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 600, fontSize: 16, boxShadow: '0 2px 6px rgba(0,0,0,0.15)' }}
        >
          ⚙️ Gerenciar / Personalizar contrato
        </button>
      </div>

      {/* Campo de filtro seguindo padrão do site */}
      <div className="filtro-container">
        <label className="filtro-label">Filtrar por:</label>
        <div className="filtro-input-container">
          <div className="filtro-input-wrapper">
            <input
              type="text"
              className="filtro-input"
              placeholder={`Filtrar por ${
                filtro === 'idContrato' ? 'ID do Contrato' :
                filtro === 'idCliente' ? 'ID do Cliente' :
                filtro === 'idOrcamento' ? 'ID do Orçamento' :
                filtro === 'status' ? 'Status' :
                filtro === 'valor' ? 'Valor' : filtro
              }`}
              value={valorFiltro}
              onChange={handleInputChange}
            />
            {valorFiltro && (
              <button
                className="filtro-clear-button"
                onClick={() => setValorFiltro('')}
                title="Limpar filtro"
              >
                ×
              </button>
            )}
          </div>
          <div className="filtro-custom-select">
            <button
              className="filtro-custom-botao"
              onClick={() => setDropdownAberto(!dropdownAberto)}
            >
              {`Filtrar por ${
                filtro === 'idContrato' ? 'ID do Contrato' :
                filtro === 'idCliente' ? 'ID do Cliente' :
                filtro === 'idOrcamento' ? 'ID do Orçamento' :
                filtro === 'status' ? 'Status' :
                filtro === 'valor' ? 'Valor' : filtro
              }`}
              <span className="seta-para-baixo">▼</span>
            </button>
            {dropdownAberto && (
              <div className="filtro-custom-opcoes">
                <div onClick={() => handleFiltroChange('idContrato')}>Filtrar por ID do Contrato</div>
                <div onClick={() => handleFiltroChange('idCliente')}>Filtrar por ID do Cliente</div>
                <div onClick={() => handleFiltroChange('idOrcamento')}>Filtrar por ID do Orçamento</div>
                <div onClick={() => handleFiltroChange('status')}>Filtrar por Status</div>
                <div onClick={() => handleFiltroChange('valor')}>Filtrar por Valor</div>
              </div>
            )}
          </div>
        </div>
      </div>


      {/* Lista de contratos filtrados */}
      <div className="lista-clientes">
        {contratosFiltrados.map((contrato, index) => {

          const contratoId = contrato.id ?? contrato.Id ?? 'N/A';
          const vendaId = contrato.vendaId ?? contrato.VendaId ?? 'N/A';
          const clienteId = contrato.id_cliente ?? contrato.Id_cliente ?? 'N/A';
          const clienteNome = contrato.ClienteNome ?? contrato.clienteNome ?? 'N/A';
          const orcamentoTitulo = contrato.OrcamentoTitulo ?? contrato.orcamentoTitulo ?? 'N/A';
          const orcamentoId = contrato.orcamentosId ?? contrato.OrcamentosId ?? 'N/A';
          const valor = contrato.valor ?? contrato.Valor ?? 'N/A';
          const status = contrato.status ?? contrato.Status ?? 'N/A';
          const statusAssinatura = contrato.statusAssinaturaDigital ?? contrato.StatusAssinaturaDigital ?? null;

          const assinaturaLabel = {
            pending:    { texto: '⏳ Aguardando assinatura', cor: '#f59e0b' },
            signed:     { texto: '✅ Assinado digitalmente', cor: '#4caf50' },
            rejected:   { texto: '❌ Recusado pelo signatário', cor: '#d32f2f' },
            expired:    { texto: '⏰ Link expirado', cor: '#9e9e9e' },
            uploaded:   { texto: '📤 Documento enviado', cor: '#1976d2' },
            partial_signed: { texto: '✍️ Assinatura parcial', cor: '#f59e0b' },
          };

          // (Removidos logs repetitivos aqui - o primeiro contrato é logado uma vez em useEffect)

          return (
            <div 
              key={`contrato-${index}-${contratoId}`} 
              className="contrato-card"
            >
              {/* Container de dados */}
              <div className="contrato-card-content">
                {/* Contrato ID - sempre visível */}
                <div className="contrato-field">
                  <label className="contrato-field-label">Contrato ID</label>
                  <span className="contrato-field-value">{contratoId}</span>
                </div>
                
                {/* Nome Cliente - sempre visível */}
                <div className="contrato-field">
                  <label className="contrato-field-label">Nome Cliente</label>
                  <span className="contrato-field-value">{clienteNome}</span>
                </div>
                
                {/* Título Oportunidade - sempre visível */}
                <div className="contrato-field">
                  <label className="contrato-field-label">Título Oportunidade</label>
                  <span className="contrato-field-value">{orcamentoTitulo}</span>
                </div>
                
                {/* Cliente ID - oculto no mobile */}
                <div className="contrato-field contrato-field-desktop">
                  <label className="contrato-field-label">Cliente ID</label>
                  <span className="contrato-field-value">{clienteId}</span>
                </div>
                
                {/* Venda ID - oculto no mobile */}
                <div className="contrato-field contrato-field-desktop">
                  <label className="contrato-field-label">Venda ID</label>
                  <span className="contrato-field-value">{vendaId}</span>
                </div>
                
                {/* Orçamento ID - oculto no mobile */}
                <div className="contrato-field contrato-field-desktop">
                  <label className="contrato-field-label">Orçamento ID</label>
                  <span className="contrato-field-value">{orcamentoId}</span>
                </div>
                
                {/* Valor - oculto no mobile */}
                <div className="contrato-field contrato-field-desktop">
                  <label className="contrato-field-label">Valor</label>
                  <span className="contrato-field-value">
                    {typeof valor === 'number' ? `R$ ${valor.toFixed(2)}` : valor}
                  </span>
                </div>
                
                {/* Status - oculto no mobile */}
                <div className="contrato-field contrato-field-desktop">
                  <label className="contrato-field-label">Status</label>
                  <span className="contrato-field-value" style={{ color: (String(status).toLowerCase() === 'assinado' ? '#4caf50' : '#d32f2f'), fontWeight: '700' }}>{status}</span>
                </div>

                {/* Badge de assinatura digital */}
                {statusAssinatura && assinaturaLabel[statusAssinatura] && (
                  <div className="contrato-field" style={{ gridColumn: '1 / -1' }}>
                    <span style={{
                      display: 'inline-block',
                      padding: '3px 10px',
                      borderRadius: '12px',
                      fontSize: '12px',
                      fontWeight: '600',
                      background: assinaturaLabel[statusAssinatura].cor + '1a',
                      color: assinaturaLabel[statusAssinatura].cor,
                      border: `1px solid ${assinaturaLabel[statusAssinatura].cor}55`
                    }}>
                      {assinaturaLabel[statusAssinatura].texto}
                    </span>
                  </div>
                )}
              </div>
              
              {/* Container de botões */}
              <div className="contrato-card-actions">
                <button
                  className="btn-baixar-contrato"
                  title={`Baixar PDF do contrato ${contratoId}`}
                  onClick={() => baixarPdfContrato(contratoId)}
                  disabled={contratoId === 'N/A'}
                >
                  Baixar PDF
                </button>
                <button
                  className="btn-editar-contrato"
                  onClick={() => setContratoEditando(contrato)}
                >
                  Editar
                </button>
              </div>
            </div>
          );
        })}
      </div>

      {/* === Popup Seleção de Cliente (Novo Contrato) === */}
      {showClientePopup && (
        <div className="popup-agendamento-overlay" onClick={fecharTodosPopupsNovo}>
          <div className="popup-agendamento" onClick={e => e.stopPropagation()} style={{ position: 'relative' }}>
            <button className="popup-fechar-btn" onClick={fecharTodosPopupsNovo} aria-label="Fechar">×</button>
            <div className="popup-agendamento-centro">
              <div className="popup-titulo-laranja">ESCOLHA UM CLIENTE</div>
              <div className="popup-lista-clientes">
                {loadingPopup && <div className="popup-card-cliente vazio">Carregando...</div>}
                {!loadingPopup && clientesLista.length === 0 && (
                  <div className="popup-card-cliente vazio">Nenhum cliente cadastrado.</div>
                )}
                {!loadingPopup && clientesLista.map(cliente => (
                  <div className="popup-card-cliente" key={cliente.id || cliente.Id}>
                    <div className="popup-card-info">
                      <span className="popup-card-id">ID: {cliente.id || cliente.Id}</span>
                      <span className="popup-card-nome">{cliente.nome || cliente.Nome}</span>
                    </div>
                    <button className="popup-card-novo-agendamento" onClick={() => handleSelecionarClienteNovo(cliente)}>
                      Selecionar
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* === Popup Seleção de Oportunidade (Novo Contrato) === */}
      {showOportunidadePopup && (
        <div className="popup-agendamento-overlay" onClick={fecharTodosPopupsNovo}>
          <div className="popup-agendamento" onClick={e => e.stopPropagation()} style={{ position: 'relative' }}>
            <button className="popup-fechar-btn" onClick={() => { setShowOportunidadePopup(false); setShowClientePopup(true); }} aria-label="Voltar">←</button>
            <button className="popup-fechar-btn" onClick={fecharTodosPopupsNovo} aria-label="Fechar" style={{ right: 12, left: 'auto' }}>×</button>
            <div className="popup-agendamento-centro">
              <div className="popup-titulo-laranja">OPORTUNIDADES DE {clienteSelecionadoNovo?.nome || clienteSelecionadoNovo?.Nome}</div>
              <div className="popup-lista-clientes">
                {loadingPopup && <div className="popup-card-cliente vazio">Carregando...</div>}
                {!loadingPopup && oportunidadesLista.length === 0 && (
                  <div className="popup-card-cliente vazio">Nenhuma oportunidade para este cliente.</div>
                )}
                {!loadingPopup && oportunidadesLista.map(op => (
                  <div className="popup-card-cliente" key={op.id || op.Id}>
                    <div className="popup-card-info">
                      <span className="popup-card-id">ID: {op.id || op.Id}</span>
                      <span className="popup-card-nome">{op.oportunidade_Titulo || op.Oportunidade_Titulo || op.titulo || op.Titulo}</span>
                    </div>
                    <button className="popup-card-novo-agendamento" onClick={() => handleSelecionarOportunidadeNovo(op)}>
                      Selecionar
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* === Popup Seleção de Orçamento (Novo Contrato) === */}
      {showOrcamentoPopup && (
        <div className="popup-agendamento-overlay" onClick={fecharTodosPopupsNovo}>
          <div className="popup-agendamento" onClick={e => e.stopPropagation()} style={{ position: 'relative' }}>
            <button className="popup-fechar-btn" onClick={() => { setShowOrcamentoPopup(false); setShowOportunidadePopup(true); }} aria-label="Voltar">←</button>
            <button className="popup-fechar-btn" onClick={fecharTodosPopupsNovo} aria-label="Fechar" style={{ right: 12, left: 'auto' }}>×</button>
            <div className="popup-agendamento-centro">
              <div className="popup-titulo-laranja">ORÇAMENTOS DA OPORTUNIDADE #{oportunidadeSelecionadaNovo?.id || oportunidadeSelecionadaNovo?.Id}</div>
              <div className="popup-lista-clientes">
                {loadingPopup && <div className="popup-card-cliente vazio">Carregando...</div>}
                {!loadingPopup && orcamentosLista.length === 0 && (
                  <>
                    <div className="popup-card-cliente vazio">Nenhum orçamento para esta oportunidade.</div>
                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: 16 }}>
                      <button
                        className="popup-card-novo-agendamento"
                        onClick={() => {
                          fecharTodosPopupsNovo();
                          navigate('/sidebar/OrcamentoDropdown', {
                            state: {
                              autoOpenForm: true,
                              clientePreSelecionado: clienteSelecionadoNovo,
                              oportunidadePreSelecionada: oportunidadeSelecionadaNovo
                            }
                          });
                        }}
                      >
                        Criar Orçamento para esta Oportunidade
                      </button>
                    </div>
                  </>
                )}
                {!loadingPopup && orcamentosLista.map(orc => (
                  <div className="popup-card-cliente" key={orc.id || orc.Id}>
                    <div className="popup-card-info">
                      <span className="popup-card-id">ID: {orc.id || orc.Id}</span>
                      <span className="popup-card-nome">{orc.descricaoOrcamento || orc.DescricaoOrcamento || orc.titulo || orc.Titulo || `Orçamento #${orc.id || orc.Id}`}</span>
                    </div>
                    <button className="popup-card-novo-agendamento" onClick={() => handleSelecionarOrcamentoNovo(orc)}>
                      Selecionar
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Formulário de edição fora do loop */}
      {contratoEditando && (
        <FormularioContrato
          contrato={contratoEditando}
          onContratoAtualizado={atualizarContratoNaLista}
          onSalvar={async (form, arquivoPDF) => {
            try {
              const isNew = !!(contratoEditando._isNew || !(contratoEditando.id || contratoEditando.Id));
              // POST para criar ou PUT para atualizar contrato
              const urls = isNew
                ? [
                    `${BASE_URL}/Contrato`,
                    `${BASE_URL}/Contrato`,
                    `${BASE_URL}/Contrato`,
                    `${BASE_URL}/Contrato`,
                    `${BASE_URL}/Contrato`
                  ]
                : [
                    `${BASE_URL}/Contrato/${contratoEditando.id || contratoEditando.Id}`,
                    `${BASE_URL}/Contrato/${contratoEditando.id || contratoEditando.Id}`,
                    `${BASE_URL}/Contrato/${contratoEditando.id || contratoEditando.Id}`,
                    `${BASE_URL}/Contrato/${contratoEditando.id || contratoEditando.Id}`,
                    `${BASE_URL}/Contrato/${contratoEditando.id || contratoEditando.Id}`
                  ];

              // Se tem PDF, precisa converter para base64
              let pdfBase64 = null;
              if (arquivoPDF) {
                const reader = new FileReader();
                pdfBase64 = await new Promise((resolve, reject) => {
                  reader.onload = () => {
                    // Remove o prefixo "data:application/pdf;base64,"
                    const base64 = reader.result.split(',')[1];
                    resolve(base64);
                  };
                  reader.onerror = reject;
                  reader.readAsDataURL(arquivoPDF);
                });
              }

              const idContrato = contratoEditando.id || contratoEditando.Id;
              let updatedOk = false;
              const failures = [];
              for (const url of urls) {
                try {
                  // Alinhar tipos com o backend: enviar null para campos inteiros vazios
                  const payload = {
                    ...(isNew ? {} : { Id: contratoEditando.id || contratoEditando.Id }),
                    OrcamentosId: form.OrcamentosId ? parseInt(form.OrcamentosId) : null,
                    Id_cliente: form.Id_cliente ? parseInt(form.Id_cliente) : null,
                    VendaId: form.VendaId ? parseInt(form.VendaId) : null,
                    Data_assinatura: form.Data_assinatura || null,
                    DataVigencia: form.DataVigencia || null,
                    Status: form.Status || null,
                    Valor: (form.Valor !== '' && !isNaN(parseFloat(form.Valor))) ? parseFloat(form.Valor) : null,
                    DescontoAdicional: (form.DescontoAdicional !== '' && !isNaN(parseFloat(form.DescontoAdicional))) ? parseFloat(form.DescontoAdicional) : null,
                    DataCriacao: form.DataCriacao || null,
                    Prazo_garantia: form.Prazo_garantia ? parseInt(form.Prazo_garantia) : null,
                    Data_garantia: form.Data_garantia || null,
                    DescricaoOrcamento: form.DescricaoOrcamento || null,
                    CondicoesPagto: form.CondicoesPagto || null,
                    ServicosContratados: form.ServicosContratados || null
                  };

                  // Adiciona o PDF se foi enviado
                  if (pdfBase64) {
                    payload.ArquivoPDFContrato = pdfBase64;
                  }

                  const response = await fetch(url, {
                    method: isNew ? 'POST' : 'PUT',
                    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + (getAuthToken() || '') },
                    body: JSON.stringify(payload)
                  });

                  if (response.ok) {
                    console.log(`✅ Contrato atualizado com sucesso em: ${url}`);
                    
                    // Verificar se retornou PDF no corpo da resposta
                    const contentType = response.headers.get('Content-Type') || response.headers.get('content-type');
                    
                    if (contentType && contentType.indexOf('application/pdf') !== -1) {
                      try {
                        const blob = await response.blob();
                        updatedOk = true;
                        // Atualiza a listagem antes de retornar o blob para o form
                        setContratoEditando(null);
                        await fetchContratos();
                        return { 
                          success: true, 
                          id: idContrato,
                          pdf: blob 
                        };
                      } catch (err) {
                        console.warn('[Contrato] recebido PDF no PUT, mas falha ao processar:', err);
                      }
                    } else if (contentType && contentType.indexOf('application/json') !== -1) {
                      try {
                        const jsonData = await response.json();
                        // Verificar se JSON contém PDF em base64
                        if (jsonData.arquivoPDFContrato || jsonData.ArquivoPDFContrato || jsonData.pdf) {
                          // Atualiza a listagem antes de retornar o PDF base64
                          setContratoEditando(null);
                          await fetchContratos();
                          return {
                            success: true,
                            id: idContrato,
                            pdf: jsonData.arquivoPDFContrato || jsonData.ArquivoPDFContrato || jsonData.pdf
                          };
                        }
                      } catch (err) {
                        console.warn('Erro ao parsear JSON da resposta:', err);
                      }
                    }
                    
                    updatedOk = true;
                    break;
                  } else {
                    // Problema HTTP. Se for 400, tentar parsear JSON de validação e abortar (erro de payload)
                    if (response.status === 400 || response.status === 500) {
                      let json = null;
                      try { json = await response.json(); } catch (e) { json = null; }
                      let reason;
                      if (json && (json.erro || json.detalhe)) {
                        reason = json.erro + (json.detalhe ? ` — ${json.detalhe}` : '') + (json.innerDetalhe ? ` (${json.innerDetalhe})` : '');
                      } else if (json && json.errors) {
                        reason = Object.keys(json.errors).map(k => `${k}: ${json.errors[k].join('; ')}`).join(' | ');
                      } else {
                        reason = `HTTP ${response.status} - ${json?.title || JSON.stringify(json) || '<sem corpo>'}`;
                      }
                      console.log(`❌ Erro ${response.status} ao salvar contrato em: ${url} ->`, json || reason);
                      const validationError = new Error(reason);
                      validationError.details = [{ url, reason }];
                      validationError.validation = json;
                      throw validationError;
                    }

                    // Tentar extrair mensagem do body para debug quando não for 400
                    let text = '';
                    try { text = await response.text(); } catch (e) { text = '<sem corpo>'; }
                    const reason = `HTTP ${response.status} - ${text}`;
                    console.log(`❌ Falha HTTP ao atualizar contrato em: ${url} -> ${reason}`);
                    failures.push({ url, reason });
                  }
                } catch (error) {
                  console.log(`❌ Erro ao atualizar contrato em: ${url} -> ${error.name}: ${error.message}`);
                  if (error && error.stack) console.log(error.stack);
                  failures.push({ url, reason: `${error.name}: ${error.message}` });
                }
              }
              
              // Se chegou aqui e updatedOk=true, significa que atualizou mas não retornou PDF
              if (updatedOk) {
                setContratoEditando(null);
                await fetchContratos();
                return { success: true, id: idContrato };
              }
              
              const err = new Error('Falha ao atualizar contrato em todas as URLs');
              err.details = failures;
              console.error('Detalhes das tentativas fracassadas:', failures);
              throw err;
              
            } catch (error) {
              console.error('❌ Erro ao salvar contrato:', error);
              // Propagar o erro para o FormularioContrato mostrar inline sem fechar o form
              throw error;
            }
          }}
          onCancelar={() => setContratoEditando(null)}
        />
      )}
    </div>
  );
}
